import { Component } from '@angular/core';

@Component({
  selector: 'app-instant-checkup-loader',
  templateUrl: './instant-checkup-loader.component.html',
})
export class InstantCheckupLoaderComponent {}
